<template>
   <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
       <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid ? submit() : ''" ref="form">
                <switch-input v-model="branch.status" label="وضعیت" tooltip="در صورت غیر فعال بودن شعبه امکان ورود سرپرستان، پرسنل و مشتریان مرتبط با آن شعبه وجود نداشته و به تبع آن امکان ثبت تیکت نیز توسط این کاربران میسر نخواهد بود."></switch-input>
                <v-text-field
                    :rules="$validation('required')"
                    label="* نام شعبه"
                    v-model="branch.name"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    label="شماره تماس"
                    v-model="branch.landline"
                    placeholder="همراه با کد شهر"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    label="نمابر"
                    v-model="branch.fax"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    label="ایمیل"
                    v-model="branch.email"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    label="وبسایت"
                    v-model="branch.website"
                ></v-text-field>
                <v-textarea
                    :rules="$validation()"
                    no-resize
                    rows="3"
                    label="توضیحات شعبه"
                    v-model="branch.description"
                ></v-textarea>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn class="ms-3" variant="text" color="error" @click="$router.push({path: '/branches'});" :disabled="loading">بازگشت</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "ویرایش",
    validate(context) {
        return context.auth.user.full_admin;
    },
   data() {
        return {
            loading: false,
            branch: {
                status: true,
                name: null,
                landline: null,
                fax: null,
                website: null,
                email: null,
                description: null,
            },
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$branchUpdate(this.$route.params.id, this.branch).then(res => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.$auth.fetchUser(true);
                    this.$router.push({path: '/branches'})
                }
            }).finally(()=>{this.loading = false});
        },
        async getBranch() {
            await this.$branchGet(this.$route.params.id).then((res) => {
                if (res && res.status == "OK") {
                    this.branch = res.data;
                }
            });
        }
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.getBranch();
            this.$loading.finish();
        });
    },
};
</script>
